import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';
import {BoardsDashboardSelector} from 'common/widgets/dashboard-selector/presets';
import {SectionItem} from 'common/components/items-menu/types';
import {Directions} from 'common/components/drop-menu/types';
import {ProjectSelectorEl} from 'common/widgets/project-selector';
import {TooltipAttrs} from 'common/components/tooltip/types';
import type {DashboardSelectorController} from 'common/report/controllers/dashboard-selector-controller';

/**
 * Returns a SectionItem object compatible with the items-menu component
 */
export function getBoardsDashboardSectionItem({
  label,
  name,
  recentDashboardIds,
  placeholder,
  quickCreateSaveDashboardCopy,
  dashboardController,
  icon,
  direction,
  offset,
  fixedParent,
  showProjectSelector,
  showMoveOutButton,
  hideDashboardList,
  excludedDashboards,
  currentDashboardHierarchyTreeHeight,
  descendantDashboardIds,
  tooltip,
  enableNestedDashboardsRestrictions,
}: {
  label: string;
  name: string;
  recentDashboardIds: number[];
  placeholder: string;
  quickCreateSaveDashboardCopy: string;
  dashboardController: DashboardSelectorController;
  enableNestedDashboardsRestrictions: boolean;
  icon?: string;
  direction?: Directions;
  offset?: number;
  fixedParent?: boolean;
  showProjectSelector?: boolean;
  showMoveOutButton?: boolean;
  hideDashboardList?: boolean;
  excludedDashboards?: number[];
  currentDashboardHierarchyTreeHeight?: number;
  descendantDashboardIds?: Set<number>;
  tooltip?: TooltipAttrs;
}): SectionItem {
  direction ||= Directions.Right;
  return {
    label,
    name,
    icon,
    tooltip,
    actionsRenderer: () => <SvgIconEl attrs={{icon: `caret-right`}} />,
    subMenuRenderer: (onValueSelected) => (
      <div style={fixedParent && {position: `fixed`, height: `41px`}}>
        <BoardsDashboardSelector
          recentDashboardIds={recentDashboardIds}
          placeholder={placeholder}
          quickCreateSaveDashboardCopy={quickCreateSaveDashboardCopy}
          dashboardController={dashboardController}
          handleDashboardSelected={(ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            onValueSelected(ev.detail.id, ev.detail);
          }}
          direction={direction}
          offset={offset}
          showProjectSelector={showProjectSelector}
          hideDashboardList={hideDashboardList}
          showMoveOutButton={showMoveOutButton}
          enableNestedDashboardsRestrictions={enableNestedDashboardsRestrictions}
          excludedDashboards={excludedDashboards}
          currentDashboardHierarchyTreeHeight={currentDashboardHierarchyTreeHeight}
          descendantDashboardIds={descendantDashboardIds}
        />
      </div>
    ),
  };
}

export function getProjectSelectorSectionItem({
  label,
  name,
  placeholder,
  quickCreateSaveDashboardCopy,
  icon,
  direction,
}: {
  label: string;
  name: string;
  placeholder: string;
  quickCreateSaveDashboardCopy: string;
  icon?: string;
  direction?: Directions;
}): SectionItem {
  direction ||= Directions.Right;
  return {
    label,
    name,
    icon,
    actionsRenderer: () => <SvgIconEl attrs={{icon: `caret-right`}} />,
    subMenuRenderer: (onValueSelected) => (
      <ProjectSelectorEl
        params={{searchPlaceholder: placeholder, submitCopy: quickCreateSaveDashboardCopy, direction, offset: 2}}
        on={{
          select: (ev: CustomEvent) => {
            ev.preventDefault();
            ev.stopPropagation();
            onValueSelected(undefined, ev.detail);
          },
        }}
      />
    ),
  };
}
